
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-69327bb6\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader!../../../vue-loader/lib/selector?type=styles&index=0!./subHeader.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./subHeader.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-69327bb6\"}!../../../vue-loader/lib/selector?type=template&index=0!./subHeader.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/muse-ui/src/subHeader/subHeader.vue
// module id = 377
// module chunks = 1